import { all, fork } from 'redux-saga/effects'
import { scormUploadWatcher, scormReplaceWatcher, scormDeleteWatcher, scormTrackWatcher } from './scorm'
import {
  loginSagaWatcher,
  logoutSagaWatcher,
  deleteSagaWatcher,
  verifyChangePasswordWatcher,
  sendForgotEmailSagaWatcher,
  refreshSagaWatcher,
  currentUserInfoSagaWatcher,
} from './authentication'

import {
  userChangePasswordPutWatcher,
  userPasswordSetWatcher,
  userRenewPasswordWatcher,
} from './user-password'
import { shopGetWatcher, shopEditWatcher, shopPatchWatcher } from './shop'
import {
  mediaImageUploadWatcher,
  mediaImageDeleteWatcher,
  openaiGenerateImageWatcher,
  mediaCardImageCreationWatcher,
} from './media-image'
import {
  mediaVideoUploadWatcher,
  mediaVideoDeleteWatcher,
  mediaVideoStreamingUploadWatcher,
} from './media-video'
import {
  mediaFolderAddAsyncWatcher,
  mediaFolderPatchWatcher,
  mediaFolderDeleteWatcher,
} from './media-folder'

import {
  userAddWatcher,
  userPatchWatcher,
  adminPatchWatcher,
  userGetWatcher,
  userValidateShortLinkWatcher,
  userGetSelfWatcher,
  userListWatcher,
  userIdListWatcher,
} from './user'

import { userLimitsGetWatcher } from './user-limits'

import {
  cardAddWatcher,
  cardPatchWatcher,
  cardLinkDeleteWatcher,
  cardMediaAddWatcher,
  cardMediaDeleteWatcher,
  cardSelectionAddWatcher,
  cardSelectionDeleteWatcher,
  cardSelectionPatchWatcher,
  paymentPatchWatcher,
  paymentDisconnectWatcher,
  cardSettingsPatchWatcher,
  cardSettingsCreateWatcher,
  cardSettingsRemoveWatcher,
  getBadgesWatcher,
  courseRemoveCardWatcher,
  courseCardLinkPatchWatcher,
  selectionDeleteWatcher,
  getCardWatcher,
  cardCloneWatcher,
  getCustomBadgesWatcher,
  createCustomBadgeWatcher,
  updateCustomBadgeWatcher,
  deleteCustomBadgeWatcher,
} from './card'

import {
  sendConfirmEmailSagaWatcher,
  confirmCodeSagaWatcher,
  signUpSagaWatcher,
  signUpRootieSagaWatcher,
  appSumosignUpSagaWatcher,
} from './sign-up'
import {
  mediaDirectoryGetRootWatcher,
  mediaDirectoryGetWatcher,
} from './media-directory'

import {
  courseListWatcher,
  courseGetWatcher,
  courseAddWatcher,
  courseEditWatcher,
  courseUpdateWatcher,
  coursePatchWatcher,
  courseReportWatcher,
  courseSettingsCreateWatcher,
  courseSettingsPatchWatcher,
  courseSettingPatchByIdWatcher,
  openAiCardRequestWatcher,
  openAiCourseCreationGetTitleRequestWatcher,
  openAiCourseCreationGetOutlineRequestWatcher,
  openaiSendCourseCreationRequestWatcher,
  templateCourseCloneWatcher,
  sendCreatePromptFromCardContentRequestWatcher,
  getCourseAnalyticsByIdWatcher,
  getCourseAnalyticsReportWatcher,
  generateQuizzesByCourseIdWatcher,
  exportCourseToScormWatcher,
  courseCreationProgressWatcher,
  editSectionOrderWatcher,
  sectionPatchWatcher,
  addSectionWatcher,
  createCourseWatcher,
  courseGetByIdWatcher,
  generateCardWatcher,
  aiInstructionWatcher,
  getCourseLandingPageWatcher,
  landingPageWatcher,
  courseFilterWatcher,
  uploadSubtitleWatcher,
  deleteSubtitleWatcher,
  getSubtitlesWatcher,
  patchSubtitleWatcher,
} from './course'

import {
  domainListWatcher,
  domainDeleteWatcher,
  domainRetryWatcher,
  domainPatchWatcher,
  domainAddWatcher,
} from './domain'

import {
  courseTimeSeriesListWatcher,
  courseTimeSeriesReportWatcher,
} from './course-time-series'

import {
  courseStatisticsListWatcher,
  courseStatisticsReportWatcher,
} from './course-statistics'

import { appsumoCodeVerifierSagaWatcher } from './appsumo-code'

import { appsumoCodeRefundSagaWatcher } from './appsumo-refund-code'

import {
  userRoleDetailedListWatcher,
  setUserRoleWatcher,
} from './user-role-detailed-list'

import {
  createCourseCollectionSagaWatcher,
  deleteCourseCollectionWatcher,
  collectionTranslateWatcher,
  collectionCloneWatcher,
  courseCollectionListWatcher,
  courseCollectionUpdateWatcher,
  courseCollectionPatchWatcher,
  getCollectionAnalyticsWatcher,
  courseCollectionAnalyticsDownloadWatcher,
} from './course-collection'

import {
  teamsListWatcher,
  teamAddWatcher,
  patchTeamWatcher,
  deleteTeamWatcher,
  teamsMemberListWatcher,
  teamsMemberDeleteWatcher,
  patchTeamMemberWatcher,
  addTeamsMemberWatcher,
  teamsMemberExportWatcher,
  teamsImportMemberWatcher,
  sendMailToLearnerWatcher,
  collectionMemberFilterWatcher,
} from './teams'

import {
  getChatsWatcher,
  sendChatMessageWatcher,
  getChatMessagesWatcher,
  updateChatMessageWatcher,
  uploadAttachmentWatcher,
  checkAttachmentStatusWatcher,
  deleteAttachmentWatcher,
  finalToolWatcher,
  getTranslatedChatContentWatcher,
} from './llm'
import {
  createCertificateSagaWatcher,
  getCertificateSagaWatcher,
  getCertificateListSagaWatcher,
  patchCertificateWatcher,
  getCertificatePaymentSettingWatcher,
  patchCertificatePaymentSettingWatcher,
  patchCertificatePriceWatcher,
} from './certificate'

import {
  aICreatorUpdateOutlineWatcher,
  aICreatorUploadAttachmentWatcher,
  aICreatorCheckAttachmentStatusWatcher,
  aICreatorDeleteAttachmentWatcher,
  aICreatorGenerateOutlineWatcher,
  aICreatorGenerateCourseWatcher,
  aICreatorGetRecentAttachmentsWatcher,
  getDocumentHeadersWatcher,
  getAttachmentTitlesWatcher,
  aICreatorSuggestGoalWatcher,
  aICreatorSuggestSectionTitleWatcher,
  aICreatorSuggestPageTitleWatcher,
  aICreatorSuggestPageOutlineWatcher,
  aICreatorAddAttachmentUrlWatcher,
} from './ai-creator'

import {
  collectionListWatcher,
  createCollectionWatcher,
  getCollectionWatcher,
  deleteCollectionWatcher,
  getCollectionCourseListWatcher,
  courseDeleteWatcher,
  editCourseCollectionIndexWatcher,
  courseCloneWatcher,
  courseTranslateWatcher,
  getCollectionSettingsWatcher,
  patchCollectionSettingWatcher,
  patchPriceWatcher,
  patchCollectionPaymentMessagesWatcher,
  patchCourseCollectionWatcher,
  getCollectionLandingPageWatcher,
  landingPageCollectionWatcher,
  inviteCollaboratorWatcher,
  collectionCollaboratorsListWatcher,
  deleteCollectionCollaboratorWatcher,
  updateCollectionCollaboratorWatcher,
  filterCollaborationCollectionListWatcher,
  acceptInvitationCollaborationWatcher,
  deleteCollectionInvitationWatcher,
  collectionShowcaseWatcher,
  setCollectionTagsWatcher,
} from './collection'

import {
  getTagListWatcher,
  createTagWatcher,
  updateTagWatcher,
  deleteTagWatcher,
} from './tag'

import { localizationsGetWatcher } from './localizations'

import { marketingGetPrimaryInterestsWatcher } from './marketing'

/**
 *
 */
export default function* rootSaga() {
  yield all([
    loginSagaWatcher(),
    logoutSagaWatcher(),
    deleteSagaWatcher(),
    verifyChangePasswordWatcher(),
    sendForgotEmailSagaWatcher(),
    refreshSagaWatcher(),
    currentUserInfoSagaWatcher(),

    userChangePasswordPutWatcher(),
    userPasswordSetWatcher(),
    userRenewPasswordWatcher(),

    userAddWatcher(),
    userPatchWatcher(),
    adminPatchWatcher(),
    userGetWatcher(),
    userValidateShortLinkWatcher(),
    userGetSelfWatcher(),
    userListWatcher(),
    userIdListWatcher(),

    cardAddWatcher(),
    cardPatchWatcher(),
    cardLinkDeleteWatcher(),
    cardSelectionAddWatcher(),
    cardSelectionDeleteWatcher(),
    cardMediaAddWatcher(),
    cardMediaDeleteWatcher(),
    cardSelectionPatchWatcher(),
    paymentPatchWatcher(),
    paymentDisconnectWatcher(),
    cardSettingsPatchWatcher(),
    cardSettingsCreateWatcher(),
    cardSettingsRemoveWatcher(),
    getBadgesWatcher(),
    getCustomBadgesWatcher(),
    createCustomBadgeWatcher(),
    updateCustomBadgeWatcher(),
    deleteCustomBadgeWatcher(),
    courseRemoveCardWatcher(),
    editSectionOrderWatcher(),
    selectionDeleteWatcher(),
    getCardWatcher(),
    cardCloneWatcher(),

    sendConfirmEmailSagaWatcher(),
    confirmCodeSagaWatcher(),
    signUpSagaWatcher(),
    signUpRootieSagaWatcher(),
    appSumosignUpSagaWatcher(),

    mediaDirectoryGetRootWatcher(),
    mediaDirectoryGetWatcher(),

    mediaImageUploadWatcher(),
    mediaImageDeleteWatcher(),
    mediaVideoUploadWatcher(),
    mediaVideoDeleteWatcher(),
    mediaVideoStreamingUploadWatcher(),
    mediaFolderAddAsyncWatcher(),
    mediaFolderPatchWatcher(),
    mediaFolderDeleteWatcher(),
    openaiGenerateImageWatcher(),
    mediaCardImageCreationWatcher(),

    shopGetWatcher(),
    shopEditWatcher(),
    shopPatchWatcher(),

    courseListWatcher(),
    courseGetWatcher(),
    courseAddWatcher(),
    courseEditWatcher(),
    courseUpdateWatcher(),
    courseDeleteWatcher(),
    coursePatchWatcher(),
    courseReportWatcher(),
    courseCardLinkPatchWatcher(),
    courseSettingsCreateWatcher(),
    courseSettingsPatchWatcher(),
    courseSettingPatchByIdWatcher(),
    openAiCardRequestWatcher(),
    aiInstructionWatcher(),
    openAiCourseCreationGetTitleRequestWatcher(),
    openAiCourseCreationGetOutlineRequestWatcher(),
    openaiSendCourseCreationRequestWatcher(),
    templateCourseCloneWatcher(),
    sendCreatePromptFromCardContentRequestWatcher(),
    getCourseAnalyticsByIdWatcher(),
    getCourseAnalyticsReportWatcher(),
    generateQuizzesByCourseIdWatcher(),
    exportCourseToScormWatcher(),
    courseCreationProgressWatcher(),
    sectionPatchWatcher(),
    addSectionWatcher(),
    createCourseWatcher(),
    courseGetByIdWatcher(),
    generateCardWatcher(),
    domainListWatcher(),
    domainDeleteWatcher(),
    domainRetryWatcher(),
    domainPatchWatcher(),
    domainAddWatcher(),
    getCourseLandingPageWatcher(),
    landingPageWatcher(),
    courseFilterWatcher(),

    courseTimeSeriesListWatcher(),
    courseStatisticsListWatcher(),
    courseTimeSeriesReportWatcher(),
    courseStatisticsReportWatcher(),

    appsumoCodeVerifierSagaWatcher(),

    appsumoCodeRefundSagaWatcher(),

    userRoleDetailedListWatcher(),
    setUserRoleWatcher(),

    createCourseCollectionSagaWatcher(),
    deleteCourseCollectionWatcher(),
    collectionTranslateWatcher(),
    collectionCloneWatcher(),
    patchCourseCollectionWatcher(),
    courseCollectionListWatcher(),
    courseCollectionUpdateWatcher(),
    editCourseCollectionIndexWatcher(),
    courseCloneWatcher(),
    courseCollectionPatchWatcher(),

    getCollectionAnalyticsWatcher(),
    courseCollectionAnalyticsDownloadWatcher(),
    teamsListWatcher(),
    teamAddWatcher(),
    patchTeamWatcher(),
    deleteTeamWatcher(),
    teamsMemberListWatcher(),
    teamsMemberDeleteWatcher(),
    patchTeamMemberWatcher(),
    addTeamsMemberWatcher(),
    teamsMemberExportWatcher(),
    teamsImportMemberWatcher(),
    sendMailToLearnerWatcher(),

    getChatsWatcher(),
    sendChatMessageWatcher(),
    getChatMessagesWatcher(),
    updateChatMessageWatcher(),
    uploadAttachmentWatcher(),
    checkAttachmentStatusWatcher(),
    deleteAttachmentWatcher(),
    finalToolWatcher(),
    getTranslatedChatContentWatcher(),

    createCertificateSagaWatcher(),
    getCertificateSagaWatcher(),
    getCertificateListSagaWatcher(),
    patchCertificateWatcher(),
    getCertificatePaymentSettingWatcher(),
    patchCertificatePaymentSettingWatcher(),
    patchCertificatePriceWatcher(),

    aICreatorUpdateOutlineWatcher(),
    aICreatorUploadAttachmentWatcher(),
    aICreatorCheckAttachmentStatusWatcher(),
    aICreatorDeleteAttachmentWatcher(),
    aICreatorGenerateOutlineWatcher(),
    aICreatorGenerateCourseWatcher(),
    aICreatorGetRecentAttachmentsWatcher(),
    getDocumentHeadersWatcher(),
    getAttachmentTitlesWatcher(),
    aICreatorSuggestGoalWatcher(),
    aICreatorSuggestSectionTitleWatcher(),
    aICreatorSuggestPageTitleWatcher(),
    aICreatorSuggestPageOutlineWatcher(),
    aICreatorAddAttachmentUrlWatcher(),

    collectionListWatcher(),
    createCollectionWatcher(),
    getCollectionWatcher(),
    deleteCollectionWatcher(),
    getCollectionCourseListWatcher(),
    courseTranslateWatcher(),
    getCollectionSettingsWatcher(),
    patchCollectionSettingWatcher(),

    patchPriceWatcher(),
    patchCollectionPaymentMessagesWatcher(),

    getCollectionLandingPageWatcher(),
    landingPageCollectionWatcher(),
    inviteCollaboratorWatcher(),
    collectionMemberFilterWatcher(),
    collectionCollaboratorsListWatcher(),
    deleteCollectionCollaboratorWatcher(),
    updateCollectionCollaboratorWatcher(),
    filterCollaborationCollectionListWatcher(),
    acceptInvitationCollaborationWatcher(),
    deleteCollectionInvitationWatcher(),
    collectionShowcaseWatcher(),

    userLimitsGetWatcher(),
    localizationsGetWatcher(),
    marketingGetPrimaryInterestsWatcher(),
    uploadSubtitleWatcher(),
    deleteSubtitleWatcher(),
    getSubtitlesWatcher(),
    patchSubtitleWatcher(),

    scormUploadWatcher(),
    scormReplaceWatcher(),
    scormDeleteWatcher(),
    scormTrackWatcher(),

    getTagListWatcher(),
    createTagWatcher(),
    updateTagWatcher(),
    deleteTagWatcher(),
    setCollectionTagsWatcher(),
  ])
}
